module.exports = __webpack_public_path__ + "img/journal.db565b39.svg";